import { AnimaliaListingHeroStatDTO } from '../../../../application/mappers/AnimaliaListingMapper';
import { animaliaListingDesignTokens } from '../shared/animalia-listing-design-tokens';

export class MvAnimaliaListingHeroStats extends HTMLElement {
  private stats: ReadonlyArray<AnimaliaListingHeroStatDTO> = [];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setStats(stats: ReadonlyArray<AnimaliaListingHeroStatDTO>): void {
    this.stats = [...stats];
    this.render();
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaListingDesignTokens}

        .hero-stats {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 14px;
          margin-top: 22px;
        }

        .stat-card {
          padding: 18px;
          border-radius: 18px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.12);
          color: #f7f3ed;
        }

        strong {
          display: block;
          margin-top: 8px;
          font-size: 2rem;
          font-family: Georgia, 'Times New Roman', serif;
        }

        @media (max-width: 980px) {
          .hero-stats {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 720px) {
          .hero-stats {
            grid-template-columns: 1fr;
          }
        }
      </style>

      <div class="hero-stats" aria-label="Contexto del listado">
        ${this.stats
          .map(
            (stat) => `
              <article class="stat-card">
                <span class="stat-label">${this.escapeHtml(stat.label)}</span>
                <strong>${this.escapeHtml(stat.value)}</strong>
              </article>
            `,
          )
          .join('')}
      </div>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

if (!customElements.get('mv-animalia-listing-hero-stats')) {
  customElements.define('mv-animalia-listing-hero-stats', MvAnimaliaListingHeroStats);
}
